module.exports = __webpack_public_path__ + "static/media/tyre-icon.d5d9bc76.png";